/**
 * In Document Exchange, the display name to store for a document collection upload. A single file
 * uses its base name (without extension); multiple files (zipped into one document) use the first
 * file's base name plus a count suffix.
 */
export function getUploadDisplayName(files: File[]): string {
  const firstFileBaseName = files[0].name.replace(/\.[^./\\]+$/, '')
  if (files.length === 1) {
    return firstFileBaseName
  }
  return `${firstFileBaseName} (+${files.length - 1} more)`
}
